/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module SecurityModule */

import { Collection } from 'ajs/modules/data-model/factories/collection.factory';
import { AviPermissionResource } from 'generated-types';
import { PKI_PROFILE_ITEM_TOKEN } from 'ajs/modules/security/security.tokens';

/**
 * Type of PKIProfileCollection.
 */
export type TPkiProfileCollection = typeof PKIProfileCollection;

/**
 * @description PKIProfile collection class.
 *
 * @author Satish Pednekar
 */
export class PKIProfileCollection extends Collection {
    constructor(args = {}) {
        const extendedArgs = {
            objectName: 'pkiprofile',
            windowElement: 'lazy-load',
            permissionName: AviPermissionResource.PERMISSION_PKIPROFILE,
            ...args,
        };

        super(extendedArgs);

        this.itemClass_ = this.getAjsDependency_(PKI_PROFILE_ITEM_TOKEN);
    }
}

PKIProfileCollection.ajsDependencies = [
    PKI_PROFILE_ITEM_TOKEN,
];
